import { formatMoney, getStyleChart } from "Helpers/helpFunction";
import moment from "moment";
import imageCircle from '../../../../../assets/images/Common/arount-circle.svg'

export const options = (data, FilterLabel, CommnonStore) => {
  let seriesData = []
  let plummetedList = [];
  let weakenList = [];
  let increaseList = [];
  let recuperateList = [];
  data?.rankStockNegative.filter((item) => {
    if (item?.category === 'plummeted') {
      plummetedList.push(item)
    }
    if (item?.category === 'weaken') {
      weakenList.push(item)
    }
  });
  data?.rankStockPositive.filter((item) => {
    if (item?.category === 'increase') {
      increaseList.push(item)
    }
    if (item?.category === 'recuperate') {
      recuperateList.push(item)
    }
  })
  if (data?.rankIndustry && (FilterLabel.indexOf('Ngành') > -1 || FilterLabel.length === 0)) {
    seriesData = seriesData.concat(data?.rankIndustry)
  };

  if (data?.rankStockNegative && (FilterLabel.indexOf('Hồi phục') > -1 || FilterLabel.length === 0)) {
    seriesData = seriesData.concat(recuperateList)
  }
  if (data?.rankStockPositive && (FilterLabel.indexOf('Tăng mạnh') > -1 || FilterLabel.length === 0)) {
    seriesData = seriesData.concat(increaseList)
  }
  if (data?.rankStockPositive && (FilterLabel.indexOf('Giảm mạnh') > -1 || FilterLabel.length === 0)) {
    seriesData = seriesData.concat(plummetedList)
  }
  if (data?.rankStockPositive && (FilterLabel.indexOf('Suy yếu') > -1 || FilterLabel.length === 0)) {
    seriesData = seriesData.concat(weakenList)
  }

  return {
    chart: {
      type: 'spline',
      backgroundColor: 'transparent',
      renderTo: 'container',
      defaultSeriesType: 'scatter',
      height: getStyleChart(CommnonStore, 'xuhuongdongtienbranch').height,
      events: {
        redraw: function () {
          const chart = this;
          if (chart.series && chart.series?.length > 0) {
            chart.series.map((item, key) => {
              const id = item?.options?.id
              const linePath = item?.options?.linePath

              const item1 = document.getElementById(`path-flow-${linePath}`);
              const item2 = document.getElementById(`path-flow-${linePath}`);

              if (chart?.get(id)?.graph && id && (item1 || item2) && linePath) {
                chart.get(id).graph.addClass(`highcharts-arrows-flow-${linePath}`);
              }
            })
          }
        },
        load: function () {
          const chart = this;
          var xAxis = chart.xAxis?.[0]
          var yAxis = chart.yAxis?.[0]
          const width = 600
          let widthScreenFirst = window.innerWidth
          const firstX = xAxis.toPixels(5.7) - (widthScreenFirst > 700 ? width / 2 : width / 4)
          const firstY = yAxis.toPixels(6.1) - (widthScreenFirst > 700 ? width / 2 : width / 4)

          var imageFly = chart.renderer.image(imageCircle, firstX, firstY, width, width)
            .css({ 'z-index': '999' }).add(chart.imggroup);
          setInterval(() => {
            const widthScreen = window.innerWidth
            if (xAxis.series.length > 0 && yAxis.series.length > 0) {
              imageFly.animate({
                x: xAxis.toPixels(5.7) - (widthScreen > 700 ? width / 2 : width / 4),
                y: yAxis.toPixels(6.1) - (widthScreen > 700 ? width / 2 : width / 4),
              }, {
                duration: 300,
                height: 100,
                step: function () {
                  this.attr({
                    zIndex: -1,
                    width: widthScreen > 700 ? width : width / 2,
                    height: widthScreen > 700 ? width : width / 2,
                  })
                },
                complete: function () {
                  this.attr({
                    zIndex: -1,
                    width: widthScreen > 700 ? width : width / 2,
                    height: widthScreen > 700 ? width : width / 2,
                  })
                }
              });
            }
          }, 1000)

          if (chart.series && chart.series?.length > 0) {
            chart.series.map((item, key) => {
              const id = item?.options?.id
              const linePath = item?.options?.linePath

              const item1 = document.getElementById(`path-flow-${linePath}`);
              const item2 = document.getElementById(`path-flow-${linePath}`);

              if (chart?.get(id)?.graph && id && (item1 || item2) && linePath) {
                chart.get(id).graph.addClass(`highcharts-arrows-flow-${linePath}`);
              }
            })
          }
        }
      }
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    xAxis: {
      min: 0,
      max: 10,
      tickInterval: 0.5,
      title: {
        text: ''
      },
      tickLength: 0,
      gridLineWidth: 0.1,
      lineColor: 'transparent',
      labels: {
        enabled: false,
      }
    },
    yAxis: {
      min: 0,
      max: 10,
      tickInterval: 0.5,
      title: {
        text: ''
      },
      gridLineWidth: 0.1,
      minorTickWidth: 0,
      labels: {
        enabled: false,
      }
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      borderRadius: 0,
      borderWidth: 0,
      backgroundColor: '#131313',
      formatter: function () {
        const index = this.point.index
        const first = data?.tradingdate?.[index]?.first
        const last = data?.tradingdate?.[index]?.last

        return `<div class="ioalomryco">
        <div class="fzlgnzcgwl whlqpruvka">${this.series.name} </div>
        <div class="fzlgnzcgwl fzbjtfpdgt">Xu hướng ngày: ${moment(first).format('DD/MM/YYYY')}: ${formatMoney(this.y, 2)}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt">Xu hướng ngày: ${moment(last).format('DD/MM/YYYY')}: ${formatMoney(this.x, 2)}</div>
        </div>`;
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      spline: {
        stickyTracking: false,
        lineWidth: 1.5,
        dataLabels: [{
          enabled: true,
          allowOverlap: true,
          style: {
            textOutline: 'none',
            fontSize: '12px',
            fontWeight: 'bold',
            // color: '#ffffff'
          },
          formatter: function (item) {
            const thisData = this
            const index = thisData?.point?.index
            return `<div style="color: ${thisData?.series?.userOptions?.lineColor}">${index === 0 ? thisData?.series?.name : ''}</div>`;
          }
        }],
        marker: {
          symbol: 'circle',
          radius: 3,
        }

      },
      series: {
        dataLabels: {
          allowOverlap: true,
        }
      }
    },
    series: seriesData || []
  }
}